export default __webpack_public_path__ + "static/media/hunger1.48fc3181.png";